import { css } from 'styled-components';

export const notFoundStyles = css``;
